import { Typography } from '@mui/material'
import * as S from './PrintersManagementPage.styles'
import { useSelector } from 'src/utils/store'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { selectFulfillmentCenters } from 'src/features/selector'
import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { actions as appActions } from '../../../../state'
import { useForm } from 'react-hook-form'
import LocalPrinterSettings from '../../components/LocalPrinterSettings'
import RemotePrintersList from '../../components/RemotePrintersList'

const PrintersManagementPage = () => {
  const {
    register, watch,
  } = useForm<{ fulfillmentCenterId: number }>()

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
  }, [dispatch])

  const fulfillmentCenterId = watch('fulfillmentCenterId')

  const fulfillmentCenters = useSelector(selectFulfillmentCenters)

  const fulfillmentCenterOptions = useMemo(() => fulfillmentCenters.map((fulfillmentCenter) => ({
    id: fulfillmentCenter.id,
    description: fulfillmentCenter.name,
  })), [fulfillmentCenters])

  return (
    <S.Wrapper>
      <Typography variant='h5' fontWeight='bold'>GERENCIAMENTO DE IMPRESSORAS</Typography>
      <S.Container>
        <S.CustomSelect
          name='fulfillmentCenterId'
          inputProps={{
            ...register(
              'fulfillmentCenterId',
            ),
            'data-testid': 'fulfillment-center-select-test-id',
          }}
          autoComplete='off'
          id='fulfillmentCenterId'
          label='Selecione um FC'
          variant='outlined'
          options={fulfillmentCenterOptions}
          optionNone={false}
          type='text'
          fullWidth={false}
          autoFocus
          maxHeight='600px'
          dataTestId='fulfillment-center-select-test-id'
        />
      </S.Container>
      <LocalPrinterSettings fulfillmentCenters={fulfillmentCenters} fulfillmentCenterId={fulfillmentCenterId} />
      <RemotePrintersList fulfillmentCenterId={fulfillmentCenterId} />
    </S.Wrapper>
  )
}

export default PrintersManagementPage
